import React, { useMemo } from "react";

import { LepcPickerOmnisearch } from "../LepcPicker";
import { SupplementalAgencySection } from "../LocalAgencies/SupplementalAgencySection";

interface SupplementalLepcSectionProps {
  disabled?: boolean;
  readOnly?: boolean;
  facilityState?: string | null;
  existingAgencies?: Array<any> | null;
  primaryLepcId?: string | null;
  facilityLatitude?: number | null;
  facilityLongitude?: number | null;
  /** Override the default "LEPC" label (e.g. "CUPA" for CA facilities) */
  label?: string;
}

export const SupplementalLepcSection: React.FC<SupplementalLepcSectionProps> = ({
  disabled = false,
  readOnly = false,
  facilityState,
  existingAgencies,
  primaryLepcId,
  facilityLatitude,
  facilityLongitude,
  label = "LEPC",
}) => {
  const defaultSearch = useMemo(() => {
    if (facilityState) {
      return `state:${facilityState}`;
    }
    return "";
  }, [facilityState]);

  // Create a wrapper component that provides facility-specific search filtering
  const StateFilteredLepcPicker = (props: any) => (
    <LepcPickerOmnisearch
      {...props}
      defaultSearch={defaultSearch}
      resultFilter={(lepc) => lepc.id !== primaryLepcId}
      facilityLatitude={facilityLatitude}
      facilityLongitude={facilityLongitude}
      label={label}
    />
  );

  return (
    <SupplementalAgencySection
      disabled={disabled}
      readOnly={readOnly}
      fieldName="supplementalLepcIds"
      agencyKey="lepc"
      existingAgencies={existingAgencies}
      addButtonText={`ADDITIONAL ${label}`}
      helperText="Secondary: this agency will not be included in your report in the portal, but will receive a copy of your Tier II report."
      PickerComponent={StateFilteredLepcPicker}
      facilityLatitude={facilityLatitude}
      facilityLongitude={facilityLongitude}
      pickerDescription={`If you need to report to multiple ${label}s, choose from the list of ${label}s in your state above. If a ${label} does not have a latitude/longitude on file or if it has a P.O. Box, it will appear at the top of this list without a distance.`}
    />
  );
};
